export default __webpack_public_path__ + "static/media/logo.102027f6.svg";